<template>
  <v-container>
    <v-card max-width="500" class="mx-auto">
      <v-toolbar class="white--text" color="green">
        <v-toolbar-title>7 Day USD Profit or Loss</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon>
          <v-icon>mdi-cash</v-icon>
        </v-btn>
      </v-toolbar>

      <v-list subheader>
        <!-- <v-subheader>{{ SubTitle }}</v-subheader> -->
        <v-list-item v-if="isLoading">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="subtitle-1 text-center" cols="12">
              Calculating please wait
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-list-item>

        <!-- <v-list-item>
          <v-list-item-content>Empt Balance</v-list-item-content>
        </v-list-item> -->

        <template v-if="!isLoading">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                >Sell: {{ TotalSell.toLocaleString() }}</v-list-item-title
              >
            </v-list-item-content>

            <v-list-item-icon>
              Rate: {{ sellRate.toLocaleString() }}
            </v-list-item-icon>
          </v-list-item>
          <!-- USD Buy info of this week -->
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                >Buy: {{ TotalBuy.toLocaleString() }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-icon>
              Rate: {{ BuyRate.toLocaleString() }}
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>

          <v-card-text
            class="text-center font-weight-bold font-weight-black"
            :class="profitLoss < 0 ? 'red--text' : 'black--text'"
          >
            <p class="d-inline" :style="{ 'border-bottom': 'double 3px' }">
              {{ profitLoss.toLocaleString() }} ksh
            </p>
          </v-card-text>
        </template>
      </v-list>

      <!-- <v-card-actions>
        Profit or Loss: 
      </v-card-actions> -->
    </v-card>
  </v-container>
</template>
<script>
export default {
  props: {
    isLoading: { type: Boolean },
    sellRate: {},
    TotalSell: {},
    TotalBuy: {},
    BuyRate: {},
    profitLoss: {},
  },
};
</script>
